/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path utils
 * @description Translation util
 */
import { t, exists } from "i18next";
import { getCurrentGlobalContext } from "./../context/AppCtxProvider";
const tmodel = (key: string) => {
  const ctx = getCurrentGlobalContext();
  const modelKey = `model.${ctx.model}.${key}`;
  if (exists(modelKey)) {
    return t(modelKey);
  }
  return t(key);
};
export default tmodel;
